import { PackageTypeEnum, PackingStatus, ProductCategoryEnum, ShiftsEnum, TransactionType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum } from "class-validator";
import { ForkLiftItemsDto } from "../../fork-lift-items/dto/fork-lift-items.dto";
import { Shifts } from "../../stock-in/shifts.enum";
import { FgStockStatus } from "./fg-stock-status.enum";
import { StockStatus } from "./stock-status.enum";


export class StockDto {
    @ApiProperty()
    stockId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    totalCartons: number;
    @ApiProperty()
    totalPouches: number;
    @ApiProperty()
    loosePouches: number;
    @ApiProperty()
    pallet: number;
    @ApiProperty()
    lotNo: string;
    @ApiProperty()
    packingType: PackingStatus;
    @ApiProperty()
    transactionType: TransactionType;
    @ApiProperty()
    location: number;
    @ApiProperty()
    date: Date;
    @ApiProperty({enum:Object.values(StockStatus)})
    @IsNotEmpty()
    @IsEnum(StockStatus)
    stockType:StockStatus;
    @ApiProperty({enum:Object.values(FgStockStatus)})
    @IsNotEmpty()
    @IsEnum(FgStockStatus)
    status:FgStockStatus;
    @ApiProperty({enum:Object.values(Shifts)})
    @IsNotEmpty()
    shift:Shifts;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedUser?: string;
    @ApiProperty()
    brandId?: number;
    @ApiProperty()
    minGrade?: number;
    @ApiProperty()
    maxGrade?: number;
    @ApiProperty()
    varientId?: number;
    @ApiProperty()
    pouches?: number;
    @ApiProperty()
    pouchWeight?: number;
    @ApiProperty()
    categoryId?: number;
    @ApiProperty()
    productId?: number; //itemId
    @ApiProperty()
    count?: number; //itemId
    @ApiProperty()
    unitId?: number; //itemId
    @ApiProperty()
    palletCode?:number;
    @ApiProperty()
    palletCapacity?:number;
    @ApiProperty()
    cartonsStatus?:PackingStatus;
    @ApiProperty()
    pouchesStatus?:PackingStatus;
    @ApiProperty()
    code?:string;
    @ApiProperty()
    traceCode?:number;
    @ApiProperty()
    productCategory?:ProductCategoryEnum;
    @ApiProperty()
    uomId?: number;
    @ApiProperty()
    stockInQty?: number;
    @ApiProperty()
    jobId?: number;
    @ApiProperty()
    isDamaged?: PackingStatus;
    @ApiProperty()
    remarks?: string;
    @ApiProperty()
    warehouseIncharge?: string;
    @ApiProperty()
    zoneId?: number;
    @ApiProperty()
    packStyleId?: number;
    @ApiProperty()
    totalLoosePouches?: number
    @ApiProperty()
    jobCompleted?: boolean
    @ApiProperty()
    antibioticTestResult?:boolean
    @ApiProperty()
    reportedCases?:number
    @ApiProperty()
    reportedLP?:number
    @ApiProperty()
    packageType?: PackageTypeEnum
    @ApiProperty()
    tareWeight?: number
    @ApiProperty()
    quantity ?: number
        @ApiProperty()
    stockInType?: string;
    @ApiProperty()
    year?:number
  }